<section id="agb">
  <h2>Allgemeine Geschäftsbedingungen (AGB) der Docuty GmbH</h2>

  <h3>1. Geltungsbereich</h3>
  <p>
    (1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB“) gelten für alle Verträge über die Nutzung
    der Software-as-a-Service-Anwendung <strong>Docuty</strong> (nachfolgend „Software“), die zwischen der
  </p>
  <address>
    <strong>Docuty GmbH</strong><br>
    Regensburger Straße 90<br>
    92318 Neumarkt i.d.OPf.<br>
    Deutschland
  </address>
  <p>
    – im Folgenden „Anbieter“ –<br>
    und dem jeweiligen Nutzer – im Folgenden „Kunde“ – geschlossen werden.
  </p>
  <p>
    (2) Abweichende oder entgegenstehende Bedingungen des Kunden werden nicht anerkannt, es sei denn,
    der Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.
  </p>
  <p>
    (3) Die Leistungen richten sich in erster Linie an Unternehmen im Sinne des § 14 BGB. Die Nutzung durch
    Verbraucher (§ 13 BGB) ist grundsätzlich möglich, sofern diese die Software ausschließlich zu privaten
    Zwecken verwenden.
  </p>

  <h3>2. Vertragsgegenstand</h3>
  <p>
    (1) Gegenstand des Vertrages ist die zeitlich begrenzte Nutzung der Online-Anwendung <strong>Docuty</strong>
    zur Erstellung, Bearbeitung und Verwaltung von Dokumentationen und Protokollen über mobile Endgeräte
    (z. B. Smartphone oder Tablet) sowie über ein Web-Portal.
  </p>
  <p>
    (2) Die Software wird über das Internet bereitgestellt („Software as a Service“). Eine lokale Installation
    beim Kunden ist nicht erforderlich.
  </p>
  <p>
    (3) Der genaue Funktionsumfang ergibt sich aus der zum Zeitpunkt des Vertragsschlusses gültigen
    Leistungsbeschreibung auf der Website des Anbieters.
  </p>

  <h3>3. Vertragsschluss</h3>
  <p>
    (1) Der Vertrag über die Nutzung der Software kommt durch Registrierung des Kunden auf der Website
    <a href="https://www.docuty.de" target="_blank" rel="noopener">www.docuty.de</a>
    und die anschließende Bestätigung der Anmeldung durch den Anbieter zustande.
  </p>
  <p>
    (2) Der Kunde erkennt diese AGB durch Aktivierung der entsprechenden Checkbox bei der Registrierung an.
  </p>
  <p>
    (3) Der Anbieter ist berechtigt, Registrierungen ohne Angabe von Gründen abzulehnen.
  </p>

  <h3>4. Leistungen des Anbieters</h3>
  <p>
    (1) Der Anbieter stellt die Software in der jeweils aktuellen Version zur Verfügung und sorgt für deren
    Betrieb und Wartung.
  </p>
  <p>
    (2) Der Anbieter kann die Software weiterentwickeln, Funktionen ändern oder ergänzen, sofern dies für
    den Kunden zumutbar ist.
  </p>
  <p>
    (3) Der Anbieter gewährleistet eine Verfügbarkeit der Software von 98 % im Monatsmittel, ausgenommen
    Wartungszeiten und Zeiten, in denen die Software aufgrund von technischen oder sonstigen Problemen,
    die nicht im Einflussbereich des Anbieters liegen (z. B. höhere Gewalt, Fremdverschulden,
    Internetstörungen), nicht erreichbar ist.
  </p>

  <h3>5. Nutzungsrechte</h3>
  <p>
    (1) Der Anbieter räumt dem Kunden ein einfaches, nicht übertragbares, nicht unterlizenzierbares Recht ein,
    die Software für die Dauer des Vertrages gemäß diesen AGB zu nutzen.
  </p>
  <p>
    (2) Eine Weitergabe der Zugangsdaten oder Nutzung durch Dritte außerhalb der eigenen Organisation des
    Kunden ist nicht gestattet.
  </p>

  <h3>6. Preise und Zahlungsbedingungen</h3>
  <p>
    (1) Die Nutzung der Software erfolgt gegen Entgelt. Die jeweils gültigen Preise sind auf der Website des
    Anbieters angegeben.
  </p>
  <p>
    (2) Der Kunde kann zwischen monatlicher oder jährlicher Abrechnung wählen.
  </p>
  <p>
    (3) Die Zahlung erfolgt per Kreditkarte oder SEPA-Lastschriftverfahren über den auf der Website
    angegebenen Zahlungsdienstleister.
  </p>
  <p>
    (4) Alle Preise verstehen sich netto zuzüglich der jeweils geltenden gesetzlichen Umsatzsteuer.
  </p>

  <h3>7. Laufzeit und Kündigung</h3>
  <p>
    (1) Der Vertrag wird wahlweise mit monatlicher oder jährlicher Laufzeit geschlossen.
  </p>
  <p>
    (2) Beide Vertragsparteien können den Vertrag mit einer Frist von einem Monat zum Ende der jeweiligen
    Laufzeit kündigen.
  </p>
  <p>
    (3) Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
  </p>
  <p>
    (4) Die Kündigung kann schriftlich oder in Textform (z. B. per E-Mail) erfolgen.
  </p>

  <h3>8. Testphase (optional)</h3>
  <p>
    (1) Der Anbieter kann Kunden eine kostenlose Testphase anbieten.
  </p>
  <p>
    (2) Während dieser Zeit besteht kein Anspruch auf eine bestimmte Verfügbarkeit oder Support.
  </p>
  <p>
    (3) Nach Ablauf der Testphase wird der Zugang automatisch deaktiviert, sofern der Kunde keinen
    kostenpflichtigen Vertrag abschließt.
  </p>

  <h3>9. Haftung</h3>
  <p>
    (1) Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der
    Gesundheit sowie für Schäden, die auf vorsätzlichem oder grob fahrlässigem Verhalten beruhen.
  </p>
  <p>
    (2) Bei einfacher Fahrlässigkeit haftet der Anbieter nur für Schäden aus der Verletzung einer wesentlichen
    Vertragspflicht (Kardinalpflicht), jedoch begrenzt auf den typischerweise vorhersehbaren Schaden.
  </p>
  <p>
    (3) Eine weitergehende Haftung ist ausgeschlossen.
  </p>

  <h3>10. Datenschutz</h3>
  <p>
    (1) Der Anbieter verarbeitet personenbezogene Daten des Kunden ausschließlich im Rahmen der geltenden
    Datenschutzgesetze und der auf der Website einsehbaren Datenschutzerklärung.
  </p>
  <p>
    (2) Der Kunde bleibt Verantwortlicher im Sinne der DSGVO für die von ihm in die Software eingegebenen
    Daten. Der Anbieter handelt insoweit als Auftragsverarbeiter.
  </p>

  <h3>11. Schlussbestimmungen</h3>
  <p>
    (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
  </p>
  <p>
    (2) Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist – soweit gesetzlich zulässig –
    Neumarkt i.d.OPf.
  </p>
  <p>
    (3) Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein, bleibt die Wirksamkeit
    der übrigen Bestimmungen unberührt.
  </p>

  <p>
    <em>Stand: Oktober 2025</em>
  </p>
</section>
